export const TypesTrunk = [
  { id: 'DIGIVOICE', name: 'DIGIVOICE' },
  { id: 'DAHDI', name: 'DAHDI' },
  { id: 'KHOMP', name: 'KHOMP' }
];
